import { IShippingClassItem } from '@models/shipping-classes/shipping-class';
import { IShippingClassHeaderItem } from './shipping-class-header';

export interface IShippingClassResponse {
    data: IShippingClassItem[];
    header: IShippingClassHeaderItem[];
    shipping_class_poa_message_website: { [key: string]: string };
    shipping_class_poa_message_order: { [key: string]: string };
}
